import moment from "moment";
const displayUser = (displayName = '', displayDt = '') => {
  if (displayName === '' || displayDt === '') {
    return '';
  }
  return `${displayName} ${moment(displayDt).format('YYYY-MM-DD HH:mm:ss')} UTC`;
};
const generateOptions = obj => {
  const options = Object.entries(obj).map(([value, label]) => {
    return {
      value: value,
      label: label
    };
  });
  return options;
};
export { displayUser, generateOptions };